module.exports = __webpack_public_path__ + "static/media/virtualTeamIcon.986285e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/virtualTeamIcon.png
// module id = 487
// module chunks = 0